import React from 'react';
import { useUrlParams } from '../../../../hooks/useUrlParams';
import { useLook } from '../../useLook';
import { VariantCell } from '../../../Grid';

import './LooksCarouselMobileModalVariants.scss';

export const LooksCarouselMobileModalVariants = () => {
  const {
    params: { look: lookId }
  } = useUrlParams();
  const { variants } = useLook(lookId);

  return (
    <div className="LooksCarouselMobileModalVariants">
      {variants.map(
        variant =>
          variant && (
            <VariantCell
              className="LooksCarouselMobileModalVariants__cell"
              key={variant.id}
              variant={variant}
            />
          )
      )}
    </div>
  );
};
